import axios from "axios";
import router from "@/router";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000, // request timeout
});

// request interceptor
let isError = false;
service.interceptors.request.use(
  (config) => {
    // if (config.url.includes("/auth/token")) {
    //   isError = false;
    // }
    setTimeout(() => {
      isError = false;
    }, 5000)
    // do something before request is sent
    config.headers.lang = "zh_CN";
    config.headers["enterprise_id"] = '1793914133554372610';
    if (process.env.NODE_ENV == "development") {
      config.headers["enterprise_name"] = "zhm";
      config.headers["module_code"] = "ims";
    }
    if (store.getters.token) {
      config.headers["Authorization"] = getToken();
    }
    if(localStorage.getItem('SIGN_TOKEN')) {
      config.headers["AUTH_TOKEN"] = localStorage.getItem('SIGN_TOKEN');
    }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data;
    if (response.config.url.indexOf('/sign-api') > -1) {
      if (res.code != 0) {
        Message({
          message: res.msg || "Error",
          type: "error",
          duration: 5 * 1000,
        });
      }
      console.log(res)
      return res
    }
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200 && res.responseCode !== 0  && toString.call(res) !== "[object Blob]") {
      if (res.code === 401 || res.code == 403) {
        if (!isError) {
          isError = true;
          Message({
            message: "账号状态发生改变, 请重新登录！",
            type: "error",
            duration: 5 * 1000,
          });
        }
        store.dispatch("user/resetToken").then(() => {
          router.replace("/login");
        });
      } else if (res.code === 602) {
        return Promise.reject(res);
      } else {
        if (!isError) {
          Message({
            message: res.msg || "Error",
            type: "error",
            duration: 5 * 1000,
          });
        }
      }
      return Promise.reject(res);
    } else {

      if (response.config.url.includes('/downloadToFile')) {
        return res
      }

      return res;
    }
  },
  (error) => {
    if (!isError) {
      console.log("err" + error); // for debug
      Message({
        message: error.message || 'Error',
        type: "error",
        duration: 5 * 1000,
      });
    }
    return Promise.reject(error);
  }
);

export default service;
